/**
 * 订单列表筛选组件
 */

import React from 'react';
import { Input, Select, DatePicker, Button, Space, Row, Col } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
const { Option } = Select;

interface OrderFiltersProps {
    searchText: string;
    statusFilter?: string;
    channelFilter?: string;
    dateRange: [dayjs.Dayjs, dayjs.Dayjs] | null;
    onSearchTextChange: (value: string) => void;
    onStatusChange: (value?: string) => void;
    onChannelChange: (value?: string) => void;
    onDateRangeChange: (dates: [dayjs.Dayjs, dayjs.Dayjs] | null) => void;
    onSearch: () => void;
    onReset: () => void;
}

const OrderFilters: React.FC<OrderFiltersProps> = ({
    searchText,
    statusFilter,
    channelFilter,
    dateRange,
    onSearchTextChange,
    onStatusChange,
    onChannelChange,
    onDateRangeChange,
    onSearch,
    onReset,
}) => {
    return (
        <div style={{ marginBottom: 24, paddingTop: 24 }}>
            <Row gutter={[16, 16]}>
                <Col span={6}>
                    <Input
                        placeholder="搜索订单号 / SKU / ASIN..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={e => onSearchTextChange(e.target.value)}
                        onPressEnter={onSearch}
                        allowClear
                    />
                </Col>
                <Col span={4}>
                    <Select
                        placeholder="订单状态"
                        style={{ width: '100%' }}
                        allowClear
                        value={statusFilter}
                        onChange={onStatusChange}
                    >
                        <Option value="Pending">Pending</Option>
                        <Option value="Unshipped">Unshipped</Option>
                        <Option value="Shipped">Shipped</Option>
                        <Option value="Canceled">Canceled</Option>
                    </Select>
                </Col>
                <Col span={4}>
                    <Select
                        placeholder="发货渠道"
                        style={{ width: '100%' }}
                        allowClear
                        value={channelFilter}
                        onChange={onChannelChange}
                    >
                        <Option value="AFN">FBA (AFN)</Option>
                        <Option value="MFN">FBM (MFN)</Option>
                    </Select>
                </Col>
                <Col span={6}>
                    <RangePicker
                        style={{ width: '100%' }}
                        value={dateRange}
                        onChange={(dates) => onDateRangeChange(dates as any)}
                    />
                </Col>
                <Col span={4}>
                    <Space>
                        <Button type="primary" onClick={onSearch} icon={<SearchOutlined />}>查询</Button>
                        <Button onClick={onReset} icon={<ReloadOutlined />}>重置</Button>
                    </Space>
                </Col>
            </Row>
        </div>
    );
};

export default OrderFilters;
